import { render } from "./PlaybackControls.vue?vue&type=template&id=7bea40ea&scoped=true"
import script from "./PlaybackControls.vue?vue&type=script&lang=js"
export * from "./PlaybackControls.vue?vue&type=script&lang=js"

import "./PlaybackControls.vue?vue&type=style&index=0&id=7bea40ea&lang=scss&scoped=true"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bea40ea"]])

export default __exports__